var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { CreateAppSheetContainer, CreateAppTypeCardRow, CreateAppTypeHeaderSubTitle, CreateAppTypeHeaderText, } from '../styles';
import createFromScratchImage from '../../../images/scratch.png';
import createFromTemplateImage from '../../../images/template.png';
import CreateTypeCard from './../components/CreateAppTypeCard';
import { changeAppNameAndLogo, listCategories, loadInitialTemplates, setCreateAppStep, } from '@project/store/createAppFlow/actions';
import { AppCreationScreens, AppEditTypes, } from '@project/store/createAppFlow/models';
import { useLocation, useParams } from 'react-router-dom';
import { selectMe } from '@project/containers/Root/selectors';
import { useSelector } from 'react-redux';
import { getFiles } from '../../../store/environment/actions';
var CreateAppTypeSelection = function () {
    var dispatch = useDispatch();
    var pathname = useLocation().pathname;
    var params = useParams();
    var name = useSelector(selectMe).name;
    var startAppCreationStepAndType = function (name, type) {
        dispatch(setCreateAppStep(name, type, AppCreationScreens.SET_NAME_AND_ICON, AppCreationScreens.SELECT_TYPE));
        if (type === 'TEMPLATE') {
            if (pathname === null || pathname === void 0 ? void 0 : pathname.includes('organizations/')) {
                dispatch(listCategories(params === null || params === void 0 ? void 0 : params.organizationId));
                dispatch(getFiles("org:".concat(params === null || params === void 0 ? void 0 : params.organizationId)));
            }
            dispatch(loadInitialTemplates(params === null || params === void 0 ? void 0 : params.organizationId));
        }
    };
    useEffect(function () {
        dispatch(changeAppNameAndLogo("".concat(name, "'s Awesome App"), AppEditTypes.NAME));
        dispatch(changeAppNameAndLogo("", AppEditTypes.LOGO));
    }, [dispatch, name]);
    return (_jsxs(CreateAppSheetContainer, __assign({ appTypeSelection: true }, { children: [_jsxs(CreateAppTypeHeaderSubTitle, __assign({ selectAppTypePage: true }, { children: ["Hi ".concat(name), ","] })), _jsx(CreateAppTypeHeaderText, { children: "Choose how you want to start" }), _jsxs(CreateAppTypeCardRow, __assign({ selectAppTypePage: true }, { children: [_jsx(CreateTypeCard, { left: true, imageHeight: 123, imageWidth: 100, image: createFromScratchImage, headerText: "Start from Scratch", subTitleText: "Start with a blank canvas, then build everything exactly as you want", onClick: function () {
                            return startAppCreationStepAndType('SET_NAME_AND_ICON', 'SCRATCH');
                        } }), _jsx(CreateTypeCard, { right: true, imageHeight: 123, imageWidth: 65, image: createFromTemplateImage, headerText: "Start with Template", subTitleText: "Start with a designer-built template and then customize it to your needs", onClick: function () {
                            return startAppCreationStepAndType('EXPLORE_TEMPLATES', 'TEMPLATE');
                        } })] }))] })));
};
export default CreateAppTypeSelection;
